export class NativeStreamSamplingConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "dryRun",
            "baseName": "dryRun",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "subjectWhen",
            "baseName": "subjectWhen",
            "type": "string",
            "format": ""
        },
        {
            "name": "rate",
            "baseName": "rate",
            "type": "number",
            "format": "double"
        },
        {
            "name": "distributionFeatures",
            "baseName": "distributionFeatures",
            "type": "Array<NativeStreamSamplingFeature>",
            "format": ""
        },
        {
            "name": "alpha",
            "baseName": "alpha",
            "type": "number",
            "format": "double"
        },
        {
            "name": "minKeepProb",
            "baseName": "minKeepProb",
            "type": "number",
            "format": "double"
        },
        {
            "name": "holdoutRate",
            "baseName": "holdoutRate",
            "type": "number",
            "format": "double"
        },
        {
            "name": "untrackedAction",
            "baseName": "untrackedAction",
            "type": "NativeStreamUntrackedAction",
            "format": ""
        },
        {
            "name": "weightMode",
            "baseName": "weightMode",
            "type": "NativeStreamWeightMode",
            "format": ""
        },
        {
            "name": "weightColumn",
            "baseName": "weightColumn",
            "type": "string",
            "format": ""
        },
        {
            "name": "holdoutColumn",
            "baseName": "holdoutColumn",
            "type": "string",
            "format": ""
        },
        {
            "name": "wouldKeepColumn",
            "baseName": "wouldKeepColumn",
            "type": "string",
            "format": ""
        },
        {
            "name": "bootstrapRows",
            "baseName": "bootstrapRows",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "bootstrapSeconds",
            "baseName": "bootstrapSeconds",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "sketchCapacity",
            "baseName": "sketchCapacity",
            "type": "number",
            "format": ""
        },
        {
            "name": "windowSeconds",
            "baseName": "windowSeconds",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "bucketSeconds",
            "baseName": "bucketSeconds",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "rowIdentityColumn",
            "baseName": "rowIdentityColumn",
            "type": "string",
            "format": ""
        },
        {
            "name": "refreshIntervalSeconds",
            "baseName": "refreshIntervalSeconds",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamSamplingConfig.attributeTypeMap;
    }
    constructor() {
    }
}
